const experience = [
  {
    company: "Amazon",
    position: "Software Development Engineer Intern",
    date: "May 2026 - Aug 2026",
    tech: "Java, Voice AI, Distributed Systems",
    bulletPoints: [
      <>Owned the end-to-end development of a <b>voice-initiated calling feature</b>, from natural-language interaction and technical design through implementation, testing, and device validation.</>,
      <>Built production-quality <b>Java components</b> that coordinated multiple distributed services, with robust input validation, privacy-safe logging, and <b>92%+ line coverage</b>.</>,
      <>Authored technical design documents, evaluated architectural trade-offs, and incorporated feedback from senior engineers through iterative design and code reviews.</>,
    ],
    link: "https://www.linkedin.com/company/amazon/",
    image: `${process.env.PUBLIC_URL}/amazon_logo.jpg`,
  },
  {
    company: "Netverge Services",
    position: "Software Engineering Intern",
    date: "Apr 2025 - Aug 2025",
    tech: "Next.js, Django REST, PostgreSQL, Redis, Docker",
    bulletPoints: [
      <>Led development of an <b>AI-powered dashboard</b> for <b>Managed Service Providers</b> (300+ clients), featuring <b>real-time reports</b> and a <b>multi-agent LLM system</b> that predicts incidents and orchestrates <b>automated resolutions</b>.</>,
      <>Optimized the <b>Next.js + Django API</b> layer, reducing <b>page-load times by 40%</b> by consolidating overlapping endpoint requests and implementing <b>smart caching strategies</b>.</>,
      <>Shipped <b>80+ features and bug fixes</b> to production; automated repetitive workflows, reducing <b>manual workload by 80%</b>.</>,
      <>Presented the platform live at the <b>2025 Web Summit Tech Conference</b> to industry professionals, including customers, partners, and investors.</>,
    ],
    link: "https://www.linkedin.com/company/netverge-services/",
    image: `${process.env.PUBLIC_URL}/netverge.png`,
  },
  {
    company: "UBC Visual Cognition Lab",
    position: "Software Developer",
    date: "Feb 2025 - Present",
    tech: "React, MongoDB, Tailwind",
    bulletPoints: [
      <>Rebuilt the lab's website to improve <b>accessibility, performance, and usability</b>, and developed an <b>AI assistant</b> for exploring research.</>,
    ],
    link: "https://viscoglab.psych.ubc.ca/",
    image: `${process.env.PUBLIC_URL}/vcl_logo.png`,
  },
  {
    company: "MINT Design Team",
    position: "Software Engineer",
    date: "Jan 2025 - Present",
    tech: "React Native, Python, scikit-learn",
    bulletPoints: [
      <>Developed a <b>hands-free mobile interface</b> using <b>EEG signals</b> and <b>iOS Switch Control</b> for users with motor impairments.</>,
      <>Built <b>calibration and machine learning pipelines</b> for real-time binary classification of EEG commands.</>,
    ],
    link: "https://ubcmint.github.io/",
    image: `${process.env.PUBLIC_URL}/mint_logo.png`,
  },
];

export default experience;
